module.exports = __webpack_public_path__ + "images/products-groups-5493d995.svg";